export default __webpack_public_path__ + "static/Economic Model Whitepaper - Russian-3b110f769d3289abc630dd5f60bacf09.pdf";